// ============================================================
// Datei: src/components/ressortDescriptionModal/RessortDescriptionModal.jsx
// ============================================================

import React from "react";
import "../../styles/ressortDescriptionModal.css";

const RessortDescriptionModal = ({ department, descriptions = [], onClose }) => {

    // ------------------------------------------------------------
    // Sicherheitscheck
    // ------------------------------------------------------------
    if (!department) return null;

    // ------------------------------------------------------------
    // Textformatierung
    // - unterstützt Absätze
    // - unterstützt Bulletpoints mit "- "
    // ------------------------------------------------------------
    const renderFormattedText = (text) => {
        if (!text) return null;

        const lines = text.split("\n");
        const elements = [];
        let listItems = [];

        lines.forEach((line, index) => {
            const trimmed = line.trim();

            if (trimmed.startsWith("- ")) {
                listItems.push(trimmed.replace("- ", ""));
                return;
            }

            if (listItems.length > 0) {
                elements.push(
                    <ul key={`list-${index}`} className="ressort-list">
                        {listItems.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                );
                listItems = [];
            }

            if (trimmed.length > 0) {
                elements.push(
                    <p key={index} className="ressort-description-text">
                        {trimmed}
                    </p>
                );
            }
        });

        if (listItems.length > 0) {
            elements.push(
                <ul key="last-list" className="ressort-list">
                    {listItems.map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            );
        }

        return elements;
    };

    return (
        <div
            className="ressort-modal-overlay"
            onClick={onClose}
        >
            <div
                className="ressort-modal-card"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="ressort-description-title"
            >
                <h2 id="ressort-description-title" className="ressort-title">
                    {department}
                </h2>

                {descriptions.length > 0 ? (
                    descriptions.map((desc, index) => (
                        <div key={index} className="ressort-description-block">
                            <h3 className="ressort-subtitle">{desc.title}</h3>
                            {renderFormattedText(desc.description)}
                        </div>
                    ))
                ) : (
                    <div className="ressort-description-block">
                        <p className="ressort-description-text">
                            Für dieses Ressort ist aktuell keine Beschreibung vorhanden.
                        </p>
                    </div>
                )}

                <button
                    className="ressort-modal-close-button"
                    onClick={onClose}
                    type="button"
                >
                    Schliessen
                </button>
            </div>
        </div>
    );
};

export default RessortDescriptionModal;